import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-53cb3bce"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ShippingHistory_operationWrapper" }
const _hoisted_2 = { class: "paging_container" }
const _hoisted_3 = { class: "page_wrapper" }
const _hoisted_4 = { class: "page_wrapper" }
const _hoisted_5 = { class: "ShippingHistory_BtnBlock" }
const _hoisted_6 = ["disabled"]
const _hoisted_7 = {
  key: 1,
  class: "loading"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"display":"inline-block"} }, "ダウンロード", -1))
const _hoisted_9 = { class: "ShippingHistory_Table" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "TH_Small" }, "照会", -1))
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { class: "ShippingHistory_Table_Sticky_TD1" }
const _hoisted_14 = { class: "ShippingHistory_Table_Sticky_TD2" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "horyusaisyukkoari" }, "【 保留再出庫あり 】", -1))
const _hoisted_17 = {
  key: 1,
  class: "juchuNumber_wrapper_false"
}
const _hoisted_18 = ["onClick"]
const _hoisted_19 = ["onClick"]
const _hoisted_20 = {
  key: 0,
  class: "ResultMessageNull"
}
const _hoisted_21 = { class: "ShippingHistory_Table Table_Meisai" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "短冊メモ", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "納品書備考", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "作業備考", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "明細No", -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "保留再出庫", -1))
const _hoisted_28 = { key: 0 }
const _hoisted_29 = { class: "ShippingHistory_Table_Sticky_TD1" }
const _hoisted_30 = { class: "ShippingHistory_Table_Sticky_TD2" }
const _hoisted_31 = ["onClick"]
const _hoisted_32 = { key: 0 }
const _hoisted_33 = ["onClick"]
const _hoisted_34 = {
  key: 0,
  class: "ResultMessageNull"
}

import axios from "axios";
import OrderHeader from "../components/OrderHeader.vue";
import PankuzuHeader from "../components/PankuzuHeader.vue";
// import ModalOrderSearchMemo from "../components/modal/ModalOrderSearchMemo.vue";
// import ModalOrderSearchVan from "../components/modal/ModalOrderSearchVan.vue";
import { ref } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import Paginate from "vuejs-paginate-next";
import { SyukkoData, SyukkoDetailData } from "@/types/syukko";
import { Notyf } from "notyf";
import CsvHelper from "../functions/CsvHelper.js";
import SelectBarSingle from "@/components/molecules/selectBarSingle.vue";

interface ShowSyukkoDetailData extends SyukkoDetailData {
  isBgGray: boolean;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'ShippingHistory',
  props: {
  isActive_SidebarFlg: { type: Boolean },
},
  emits: ["toggleGlobalHeader", "showGlobalHeader"],
  setup(__props) {

const notyf = new Notyf();
const router = useRouter();
const store = useStore();
const props = __props;
const { getTimeStamp } = CsvHelper();


// ストアの初期化------------------------------------------------
store.commit("search/clearAuthData");

//ぱんくずヘッダー
const currentPathList = [{ name: "販売履歴" }, { name: "出庫履歴検索" }];
// テーブル表示項目----------------------------------------------

let searchAreaToggle: boolean = true;
let search_result = ref<SyukkoData[]>([]); // 見出し
// 明細表示用の型（背景色用のプロパティ追加）
let search_meisai_result = ref<ShowSyukkoDetailData[]>([]); // 明細

// レイアウト切替関連--------------------------------------------
const selectBar_layout = ref({
  title: "レイアウト",
  select_list: [
    { name: "見出し", selectFlg: true },
    { name: "明細", selectFlg: false },
  ],
});
const isActiveMeisaiFlg = ref(false);
const updateSelectLayout = (layout: any) => {
  if (layout.name == "見出し") {
    isActiveMeisaiFlg.value = false;
  } else {
    isActiveMeisaiFlg.value = true;
  }
};

// ソート関連-------------------------------------------------
// 【見出し】
// 変数
const midasiSortInfo = ref({
  sortItem: "",
  isKoujun: false,
});
const isMidasiSorting = ref(false);
// 関数
const sortMidasiTable = async (sortItem: string) => {
  isMidasiSorting.value = true;
  if (midasiSortInfo.value.sortItem === sortItem) {
    midasiSortInfo.value.isKoujun = !midasiSortInfo.value.isKoujun;
  } else {
    midasiSortInfo.value.isKoujun = false;
    // 別のソートに切り替えたときページネーションを1にする
    currentPage.value = 1;
    store.commit("search/setPageNumber", currentPage.value);
  }
  midasiSortInfo.value.sortItem = sortItem;
  getSyukkoData();
};
const showMidasiSortSymbol = (sortItem: string) => {
  if (
    isMidasiSorting.value &&
    midasiSortInfo.value.sortItem === sortItem &&
    midasiSortInfo.value.isKoujun
  ) {
    return "▼";
  } else if (
    isMidasiSorting.value &&
    midasiSortInfo.value.sortItem === sortItem &&
    !midasiSortInfo.value.isKoujun
  ) {
    return "▲";
  } else {
    return "";
  }
};

// 【明細】
// 変数
const meisaiSortInfo = ref({
  sortItem: "",
  isKoujun: false,
});
const isMeisaiSorting = ref(false);
// 関数
const sortMeisaiTable = async (sortItem: string) => {
  isMeisaiSorting.value = true;

  if (meisaiSortInfo.value.sortItem === sortItem) {
    meisaiSortInfo.value.isKoujun = !meisaiSortInfo.value.isKoujun;
  } else {
    meisaiSortInfo.value.isKoujun = false;
    // 別のソートに切り替えたときページネーションを1にする
    meisaiCurrentPage.value = 1;
    store.commit("search/setSyukkoMeisaiPageNumber", meisaiCurrentPage.value);
  }
  meisaiSortInfo.value.sortItem = sortItem;
  getSyukkoMeisaiData();
};
const showMeisaiSortSymbol = (sortItem: string) => {
  if (
    isMeisaiSorting.value &&
    meisaiSortInfo.value.sortItem === sortItem &&
    meisaiSortInfo.value.isKoujun
  ) {
    return "▼";
  } else if (
    isMeisaiSorting.value &&
    meisaiSortInfo.value.sortItem === sortItem &&
    !meisaiSortInfo.value.isKoujun
  ) {
    return "▲";
  } else {
    return "";
  }
};

//検索ヘッダ関連----------------------------------------------
let isActiveKaniFlg = ref<boolean>(false);
let isActive_SyosaiFlg = ref<boolean>(true);
let isOpentoggleArea = ref<boolean>(true);
const changeKaniFlg = (KaniFlg: boolean): void => {
  isActiveKaniFlg.value = KaniFlg;
};
const changeSyosaiFlg = (SyosaiFlg: boolean): void => {
  isActive_SyosaiFlg.value = SyosaiFlg;
};

const changeToggleArea = (toggleAreaFlg: boolean): void => {
  isOpentoggleArea.value = toggleAreaFlg;
};

//検索処理
const onSearch = (): void => {
  store.commit("search/resetPage");
  currentPage.value = 1;
  isMidasiSorting.value = false;
  store.commit("search/resetSyukkoMeisaiPage");
  meisaiCurrentPage.value = 1;
  isMeisaiSorting.value = false;

  getSyukkoData();
  getSyukkoMeisaiData();
};
// 見出しデータ取得
const getSyukkoData = async (): Promise<void> => {
  search_result.value.splice(0);
  if (isMidasiSorting.value) {
    await store.dispatch("search/sortSyukko", {
      sortItem: midasiSortInfo.value.sortItem,
      isKoujun: midasiSortInfo.value.isKoujun,
    });
  } else {
    await store.dispatch("search/searchSyukko");
  }
  const res = store.getters["search/getSyukkoData"];
  res.syukkoList.forEach((syukko: SyukkoData) => {
    search_result.value.push(syukko);
  });
  numberOfTotalData.value = res.size;
  firstCount.value = res.firstCount;
  finalCount.value = res.finalCount;

  getTotalPage();
};
getSyukkoData();
// 明細データ取得
const getSyukkoMeisaiData = async (): Promise<void> => {
  search_meisai_result.value.splice(0);
  if (isMeisaiSorting.value) {
    await store.dispatch("search/sortSyukkoMeisai", {
      sortItem: meisaiSortInfo.value.sortItem,
      isKoujun: meisaiSortInfo.value.isKoujun,
    });
  } else {
    await store.dispatch("search/searchSyukkoMeisai");
  }
  const res = store.getters["search/getSyukkoMeisaiData"];

  let isBgGray = true;
  let preJuchuId = "";
  res.syukkoDetailList.forEach((syukko: SyukkoDetailData) => {
    //テーブル背景色の判定のため、受注番号ごとで明細を仕分けする
    if (preJuchuId !== syukko.juchuNumber) {
      isBgGray = !isBgGray;
    }
    search_meisai_result.value.push({ isBgGray: isBgGray, ...syukko });
    preJuchuId = syukko.juchuNumber;
  });

  meisaiNumberOfTotalData.value = res.size;
  meisaiFirstCount.value = res.firstCount;
  meisaiFinalCount.value = res.finalCount;

  getMeisaiTotalPage();
};
getSyukkoMeisaiData();

// ページネーション関連処理-----------------------------------------
// 1ページあたりの表示データ数(一旦固定)
let dataPerPage = 100;
store.commit("search/setNumberOfDisplay", dataPerPage);

/* 見出し */
// 取得データ合計
let numberOfTotalData = ref(0);
// 総ページ数
const numberOfTotalPage = ref(0);
//表示中のページ範囲
let firstCount = ref(0);
let finalCount = ref(0);
// 現在のページ数
const currentPage = ref(1);
const getTotalPage = () => {
  numberOfTotalPage.value = Math.ceil(numberOfTotalData.value / dataPerPage);
};
const onClickPage = (newPage: number) => {
  currentPage.value = newPage;
  store.commit("search/setPageNumber", currentPage.value);
  getSyukkoData();
};

/* 明細 */
// 取得データ合計
let meisaiNumberOfTotalData = ref(0);
// 総ページ数
const meisaiNumberOfTotalPage = ref(0);
//表示中のページ範囲
let meisaiFirstCount = ref(0);
let meisaiFinalCount = ref(0);
// 現在のページ数
const meisaiCurrentPage = ref(1);
const getMeisaiTotalPage = () => {
  meisaiNumberOfTotalPage.value = Math.ceil(
    meisaiNumberOfTotalData.value / dataPerPage
  );
};
const onClickMeisaiPage = (newPage: number) => {
  meisaiCurrentPage.value = newPage;
  store.commit("search/setSyukkoMeisaiPageNumber", meisaiCurrentPage.value);
  getSyukkoMeisaiData();
};
//ダウンロード------------------------------------------------

let isLoading = ref(false);
const getCsvData = async () => {
  isLoading.value = false;
  const simpleState = store.getters["search/getEncodeSearchSimpleState"];
  const detailState = store.getters["search/getSyukkoDetailState"];
  try {
    isLoading.value = true;
    const searchParams = `fromTourokuDate=${
      detailState.fromTourokuDate
    }&toTourokuDate=${detailState.toTourokuDate}&fromNouhinDate=${
      detailState.fromNouhinDate
    }&toNouhinDate=${detailState.toNouhinDate}&juchuNumber=${
      detailState.juchuNumber
    }&orderNumber=${detailState.orderNumber}&eventMei=${
      detailState.eventMei
    }&toritugiCd=${detailState.toritugiCd}&cutting=${
      detailState.cutting
    }&janCd=${detailState.syosiCd}&fromHatubaiDate=${
      detailState.fromHatubaiDate
    }&toHatubaiDate=${detailState.toHatubaiDate}&syubetu=${
      detailState.syubetu
    }&categoryCd=${detailState.category}&zaikoStatus=${
      detailState.zaikoStatus
    }&syukkoStatus=${detailState.syukkoStatus}&registrant=${
      detailState.registrant
    }&toritugiSyotenCd=${detailState.toritugiSyotenCd}&salesCd=${
      detailState.salesCd !== "" ? Number(detailState.salesCd) : ""
    }&freeword=${simpleState}`;
    const res = await axios.get(
      `${store.getters["getBaseUrl"]}/syukko/download-excel?${searchParams}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
        responseType: "arraybuffer",
        responseEncoding: "binary",
      }
    );
    isLoading.value = false;
    if (res.data === "") {
      notyf.error("ダウンロードするデータがありません");
    } else {
      let blob = new Blob([res.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      let link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = `出庫履歴_${getTimeStamp()}.xlsx`;
      link.click();
      isLoading.value = false;
    }
  } catch (error) {
    isLoading.value = false;
    notyf.error("ダウンロードに失敗しました");
    console.log(error);
  }
};
//テーブルの高さ判定
const tableHeight = () => {
  if (isActive_SyosaiFlg.value && isOpentoggleArea.value) {
    //詳細ヘッダが空いているときのみテーブルを短くする
    return "ShippingHistory_TableContainer_Short";
  } else {
    //その他
    return "ShippingHistory_TableContainer_Long";
  }
};

// モーダル関連----------------------------------------------
// interface selectedProductType {
//   bikou: string;
//   bikou_date_to: string;
//   kyouseiST: string;
//   van_date_to: string;
//   van_date_from: string;
// }
// let selectedProduct = reactive<selectedProductType>({
//   bikou: "",
//   bikou_date_to: "",
//   kyouseiST: "",
//   van_date_to: "",
//   van_date_from: "",
// });
//備考
// let modalVisible_memo = ref<boolean>(false);
// const updateBikou = (bikouVal: string, date_toVal: string) => {
//   selectedProduct.bikou = bikouVal;
//   selectedProduct.bikou_date_to = date_toVal;
// };
// //van強制ST
// let modalVisible_van = ref<boolean>(false);
// const updateStatus = (statusVal: string, dateFrom: string, dateTo: string) => {
//   selectedProduct.kyouseiST = statusVal;
//   selectedProduct.van_date_from = dateFrom;
//   selectedProduct.van_date_to = dateTo;
// };
// const closeModal = (): void => {
//   if (modalVisible_memo.value) {
//     modalVisible_memo.value = false;
//   } else if (modalVisible_van.value) {
//     modalVisible_van.value = false;
//   }
// };

//参照タブ
// const openDetailTab = (resultId: number): void => {
//   let resolvedRoute = router.resolve({
//     name: "ShippingHistoryDetail",
//     params: { id: resultId },
//   });
//   window.open(
//     resolvedRoute.href,
//     "_blank",
//     "width=750,height=650,scrollbars=1,location=0,menubar=0,toolbar=0,status=1,directories=0,resizable=1,left=" +
//     (window.screen.width - 1000) / 2 +
//     ",top=" +
//     (window.screen.height - 650) / 2
//   );
// };
const openTab = async (juchuNumber: string): Promise<void> => {
  let resolvedRoute = router.resolve({
    name: "ShippingHistoryDetail",
    params: { id: juchuNumber },
  });
  window.open(
    resolvedRoute.href,
    "_blank",
    "width=1500,height=600,scrollbars=1,location=0,menubar=0,toolbar=0,status=1,directories=0,resizable=1,left=" +
      300 +
      ",top=" +
      (window.screen.height - 650) / 2
  );
};

// 本伝確定伝票NOがクリックされた時に納品伝票画面に遷移する
const openDeliverySlip = async (confirmedDenpyouNumber: string) => {
  router.push({
    path: "/deliverySlip",
    query: { denpyoNumber: confirmedDenpyouNumber },
  });
};

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["ShippingHistory", {
      Show_KaniSearch: _unref(isActiveKaniFlg),
      Show_SyosaiSearch: _unref(isActive_SyosaiFlg),
      SideBar_False: !props.isActive_SidebarFlg,
      SideBar_True: props.isActive_SidebarFlg,
    }])
  }, [
    _createVNode(PankuzuHeader, {
      isActive_SidebarFlg: props.isActive_SidebarFlg,
      currentPathList: currentPathList
    }, null, 8, ["isActive_SidebarFlg"]),
    _createVNode(OrderHeader, {
      isActiveKaniFlg: _unref(isActiveKaniFlg),
      isActive_SyosaiFlg: _unref(isActive_SyosaiFlg),
      isActive_SidebarFlg: __props.isActive_SidebarFlg,
      searchAreaToggle: _unref(searchAreaToggle),
      searchType: "shippingHistory",
      onChangeKaniFlg: changeKaniFlg,
      onChangeSyosaiFlg: changeSyosaiFlg,
      onChangeToggleArea: changeToggleArea,
      onOnSearch: onSearch
    }, null, 8, ["isActiveKaniFlg", "isActive_SyosaiFlg", "isActive_SidebarFlg", "searchAreaToggle"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _withDirectives(_createElementVNode("div", _hoisted_3, [
          _createVNode(_unref(Paginate), {
            "page-count": numberOfTotalPage.value,
            "hide-prev-next": true,
            "page-range": 3,
            "prev-text": '<',
            "next-text": '>',
            "container-class": 'pagination',
            "page-class": 'page-item',
            "page-link-class": 'page-item--link',
            "active-class": 'page-item--active',
            "click-handler": onClickPage,
            "force-page": currentPage.value
          }, null, 8, ["page-count", "force-page"]),
          _withDirectives(_createElementVNode("span", { class: "paging_result" }, " 検索結果：" + _toDisplayString(_unref(numberOfTotalData)) + "件/" + _toDisplayString(_unref(firstCount)) + "～" + _toDisplayString(_unref(finalCount)) + "件を表示", 513), [
            [_vShow, _unref(search_result).length]
          ])
        ], 512), [
          [_vShow, !isActiveMeisaiFlg.value]
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_4, [
          _createVNode(_unref(Paginate), {
            "page-count": meisaiNumberOfTotalPage.value,
            "hide-prev-next": true,
            "page-range": 3,
            "prev-text": '<',
            "next-text": '>',
            "container-class": 'pagination',
            "page-class": 'page-item',
            "page-link-class": 'page-item--link',
            "active-class": 'page-item--active',
            "click-handler": onClickMeisaiPage,
            "force-page": meisaiCurrentPage.value
          }, null, 8, ["page-count", "force-page"]),
          _withDirectives(_createElementVNode("span", { class: "paging_result" }, " 検索結果：" + _toDisplayString(_unref(meisaiNumberOfTotalData)) + "件/" + _toDisplayString(_unref(meisaiFirstCount)) + "～" + _toDisplayString(_unref(meisaiFinalCount)) + "件を表示", 513), [
            [_vShow, _unref(search_meisai_result).length]
          ])
        ], 512), [
          [_vShow, isActiveMeisaiFlg.value]
        ]),
        _createVNode(SelectBarSingle, {
          selectBarList_props: selectBar_layout.value,
          onUpdateSelectValue: updateSelectLayout,
          class: "OrderConfirm_SelectContainer"
        }, null, 8, ["selectBarList_props"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("button", {
          class: _normalizeClass(["ShippingHistory_BtnGray", { ShippingHistory_BtnDisabled: _unref(isLoading) }]),
          download: "sample.txt",
          onClick: getCsvData,
          disabled: _unref(isLoading)
        }, [
          (!_unref(isLoading))
            ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                key: 0,
                icon: "download",
                style: {"display":"inline-block"}
              }))
            : _createCommentVNode("", true),
          (_unref(isLoading))
            ? (_openBlock(), _createElementBlock("span", _hoisted_7))
            : _createCommentVNode("", true),
          _hoisted_8
        ], 10, _hoisted_6)
      ])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["ShippingHistory_TableContainer", tableHeight()])
    }, [
      (!isActiveMeisaiFlg.value)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("table", _hoisted_9, [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", {
                    class: "ShippingHistory_Table_Sticky_TH1 TH_Medium th_sort",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (sortMidasiTable('tourokuDate')))
                  }, [
                    _createElementVNode("span", null, _toDisplayString(showMidasiSortSymbol("tourokuDate")), 1),
                    _createTextVNode(" 登録日付 ")
                  ]),
                  _createElementVNode("th", {
                    class: "ShippingHistory_Table_Sticky_TH2 TH_Medium th_sort",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (sortMidasiTable('juchuNumber')))
                  }, [
                    _createElementVNode("span", null, _toDisplayString(showMidasiSortSymbol("tourokuDate")), 1),
                    _createTextVNode(" 受注番号 ")
                  ]),
                  _createElementVNode("th", {
                    class: "th_sort",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (sortMidasiTable('eventMei')))
                  }, [
                    _createElementVNode("span", null, _toDisplayString(showMidasiSortSymbol("eventMei")), 1),
                    _createTextVNode("イベント ")
                  ]),
                  _createElementVNode("th", {
                    class: "TH_Medium th_sort",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (sortMidasiTable('joukenMei')))
                  }, [
                    _createElementVNode("span", null, _toDisplayString(showMidasiSortSymbol("joukenMei")), 1),
                    _createTextVNode("取引条件 ")
                  ]),
                  _createElementVNode("th", {
                    class: "th_sort",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (sortMidasiTable('toritugiMei')))
                  }, [
                    _createElementVNode("span", null, _toDisplayString(showMidasiSortSymbol("toritugiMei")), 1),
                    _createTextVNode("取次/取引先 ")
                  ]),
                  _createElementVNode("th", {
                    class: "TH_Medium th_sort",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (sortMidasiTable('toritugiSyotenCd')))
                  }, [
                    _createElementVNode("span", null, _toDisplayString(showMidasiSortSymbol("toritugiSyotenCd")), 1),
                    _createTextVNode("書店コード ")
                  ]),
                  _createElementVNode("th", {
                    class: "th_sort",
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (sortMidasiTable('syotenMei')))
                  }, [
                    _createElementVNode("span", null, _toDisplayString(showMidasiSortSymbol("syotenMei")), 1),
                    _createTextVNode("書店/納品先 ")
                  ]),
                  _createElementVNode("th", {
                    class: "TH_Medium th_sort",
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (sortMidasiTable('nouhinDate')))
                  }, [
                    _createElementVNode("span", null, _toDisplayString(showMidasiSortSymbol("nouhinDate")), 1),
                    _createTextVNode("納品日付 ")
                  ]),
                  _createElementVNode("th", {
                    class: "TH_Medium th_sort",
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (sortMidasiTable('confirmedDenpyouNumber')))
                  }, [
                    _createElementVNode("span", null, _toDisplayString(showMidasiSortSymbol("confirmedDenpyouNumber")), 1),
                    _createTextVNode("本伝確定"),
                    _hoisted_10,
                    _createTextVNode("伝票NO ")
                  ]),
                  _hoisted_11
                ])
              ]),
              (_unref(search_result).length)
                ? (_openBlock(), _createElementBlock("tbody", _hoisted_12, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(search_result), (result, index) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        class: _normalizeClass([index % 2 !== 0 ? 'tr_bg-gray' : 'tr_bg-white', "tr-border"]),
                        key: index
                      }, [
                        _createElementVNode("td", _hoisted_13, _toDisplayString(result.tourokuDate), 1),
                        _createElementVNode("td", _hoisted_14, [
                          (result.hasHoryuSaiSyukko === true)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                _createTextVNode(_toDisplayString(result.juchuNumber) + " ", 1),
                                _hoisted_16
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(result.juchuNumber), 1))
                        ]),
                        _createElementVNode("td", null, _toDisplayString(result.eventMei), 1),
                        _createElementVNode("td", null, _toDisplayString(result.joukenMei), 1),
                        _createElementVNode("td", null, _toDisplayString(result.toritugiMei), 1),
                        _createElementVNode("td", null, _toDisplayString(result.toritugiSyotenCd), 1),
                        _createElementVNode("td", null, _toDisplayString(result.syotenMei), 1),
                        _createElementVNode("td", null, _toDisplayString(result.nouhinDate), 1),
                        _createElementVNode("td", null, [
                          (
                    result.confirmedDenpyouNumber !== null &&
                    result.confirmedDenpyouNumber !== '0'
                  )
                            ? (_openBlock(), _createElementBlock("a", {
                                key: 0,
                                onClick: ($event: any) => (openDeliverySlip(result.confirmedDenpyouNumber))
                              }, _toDisplayString(result.confirmedDenpyouNumber), 9, _hoisted_18))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("td", null, [
                          _createElementVNode("button", {
                            class: "ShippingHistory_Table_Button",
                            onClick: ($event: any) => (openTab(result.juchuNumber))
                          }, " 照会 ", 8, _hoisted_19)
                        ])
                      ], 2))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ]),
            (!_unref(search_result).length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_20, " ※検索結果はありません "))
              : _createCommentVNode("", true)
          ], 64))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("table", _hoisted_21, [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", {
                    class: "ShippingHistory_Table_Sticky_TH1 TH_Medium th_sort",
                    onClick: _cache[9] || (_cache[9] = ($event: any) => (sortMeisaiTable('tourokuDate')))
                  }, [
                    _createElementVNode("span", null, _toDisplayString(showMeisaiSortSymbol("tourokuDate")), 1),
                    _createTextVNode("登録日付 ")
                  ]),
                  _createElementVNode("th", {
                    class: "ShippingHistory_Table_Sticky_TH2 TH_Medium th_sort",
                    onClick: _cache[10] || (_cache[10] = ($event: any) => (sortMeisaiTable('juchuNumber')))
                  }, [
                    _createElementVNode("span", null, _toDisplayString(showMeisaiSortSymbol("juchuNumber")), 1),
                    _createTextVNode("受注番号 ")
                  ]),
                  _createElementVNode("th", {
                    class: "th_sort",
                    onClick: _cache[11] || (_cache[11] = ($event: any) => (sortMeisaiTable('client')))
                  }, [
                    _createElementVNode("span", null, _toDisplayString(showMeisaiSortSymbol("client")), 1),
                    _createTextVNode("依頼者 ")
                  ]),
                  _createElementVNode("th", {
                    class: "th_sort",
                    onClick: _cache[12] || (_cache[12] = ($event: any) => (sortMeisaiTable('registrant')))
                  }, [
                    _createElementVNode("span", null, _toDisplayString(showMeisaiSortSymbol("registrant")), 1),
                    _createTextVNode("登録者 ")
                  ]),
                  _createElementVNode("th", {
                    class: "th_sort",
                    onClick: _cache[13] || (_cache[13] = ($event: any) => (sortMeisaiTable('eventMei')))
                  }, [
                    _createElementVNode("span", null, _toDisplayString(showMeisaiSortSymbol("eventMei")), 1),
                    _createTextVNode("イベント ")
                  ]),
                  _createElementVNode("th", {
                    class: "TH_Medium th_sort",
                    onClick: _cache[14] || (_cache[14] = ($event: any) => (sortMeisaiTable('joukenMei')))
                  }, [
                    _createElementVNode("span", null, _toDisplayString(showMeisaiSortSymbol("joukenMei")), 1),
                    _createTextVNode("取引条件 ")
                  ]),
                  _createElementVNode("th", {
                    class: "th_sort",
                    onClick: _cache[15] || (_cache[15] = ($event: any) => (sortMeisaiTable('cycle')))
                  }, [
                    _createElementVNode("span", null, _toDisplayString(showMeisaiSortSymbol("cycle")), 1),
                    _createTextVNode("サイクル ")
                  ]),
                  _createElementVNode("th", {
                    class: "th_sort",
                    onClick: _cache[16] || (_cache[16] = ($event: any) => (sortMeisaiTable('toritugiMei')))
                  }, [
                    _createElementVNode("span", null, _toDisplayString(showMeisaiSortSymbol("toritugiMei")), 1),
                    _createTextVNode("取次/取引先 ")
                  ]),
                  _createElementVNode("th", {
                    class: "th_sort",
                    onClick: _cache[17] || (_cache[17] = ($event: any) => (sortMeisaiTable('syotenMei')))
                  }, [
                    _createElementVNode("span", null, _toDisplayString(showMeisaiSortSymbol("syotenMei")), 1),
                    _createTextVNode("書店/納品先 ")
                  ]),
                  _hoisted_22,
                  _hoisted_23,
                  _hoisted_24,
                  _createElementVNode("th", {
                    class: "TH_Medium th_sort",
                    onClick: _cache[18] || (_cache[18] = ($event: any) => (sortMeisaiTable('toritugiSyotenCd')))
                  }, [
                    _createElementVNode("span", null, _toDisplayString(showMeisaiSortSymbol("toritugiSyotenCd")), 1),
                    _createTextVNode("書店コード ")
                  ]),
                  _createElementVNode("th", {
                    class: "th_sort",
                    onClick: _cache[19] || (_cache[19] = ($event: any) => (sortMeisaiTable('bansen')))
                  }, [
                    _createElementVNode("span", null, _toDisplayString(showMeisaiSortSymbol("bansen")), 1),
                    _createTextVNode("番線/作業コード ")
                  ]),
                  _createElementVNode("th", {
                    class: "TH_Medium th_sort",
                    onClick: _cache[20] || (_cache[20] = ($event: any) => (sortMeisaiTable('confirmedDenpyouNumber')))
                  }, [
                    _createElementVNode("span", null, _toDisplayString(showMeisaiSortSymbol("confirmedDenpyouNumber")), 1),
                    _createTextVNode("本伝確定"),
                    _hoisted_25,
                    _createTextVNode("伝票NO ")
                  ]),
                  _hoisted_26,
                  _createElementVNode("th", {
                    class: "th_sort",
                    onClick: _cache[21] || (_cache[21] = ($event: any) => (sortMeisaiTable('syosiCd')))
                  }, [
                    _createElementVNode("span", null, _toDisplayString(showMeisaiSortSymbol("syosiCd")), 1),
                    _createTextVNode("商品番号 ")
                  ]),
                  _createElementVNode("th", {
                    class: "th_sort",
                    onClick: _cache[22] || (_cache[22] = ($event: any) => (sortMeisaiTable('janCd')))
                  }, [
                    _createElementVNode("span", null, _toDisplayString(showMeisaiSortSymbol("janCd")), 1),
                    _createTextVNode("ISBN13桁 ")
                  ]),
                  _createElementVNode("th", {
                    class: "th_sort",
                    onClick: _cache[23] || (_cache[23] = ($event: any) => (sortMeisaiTable('syuppanSyosiCd')))
                  }, [
                    _createElementVNode("span", null, _toDisplayString(showMeisaiSortSymbol("syuppanSyosiCd")), 1),
                    _createTextVNode("出版書誌コード ")
                  ]),
                  _createElementVNode("th", {
                    class: "th_sort",
                    onClick: _cache[24] || (_cache[24] = ($event: any) => (sortMeisaiTable('title')))
                  }, [
                    _createElementVNode("span", null, _toDisplayString(showMeisaiSortSymbol("title")), 1),
                    _createTextVNode("商品名 ")
                  ]),
                  _createElementVNode("th", {
                    class: "th_sort",
                    onClick: _cache[25] || (_cache[25] = ($event: any) => (sortMeisaiTable('hontaiPrice')))
                  }, [
                    _createElementVNode("span", null, _toDisplayString(showMeisaiSortSymbol("hontaiPrice")), 1),
                    _createTextVNode("本体価格 ")
                  ]),
                  _createElementVNode("th", {
                    class: "th_sort",
                    onClick: _cache[26] || (_cache[26] = ($event: any) => (sortMeisaiTable('juchusuu')))
                  }, [
                    _createElementVNode("span", null, _toDisplayString(showMeisaiSortSymbol("juchusuu")), 1),
                    _createTextVNode("受注数 ")
                  ]),
                  _createElementVNode("th", {
                    class: "th_sort",
                    onClick: _cache[27] || (_cache[27] = ($event: any) => (sortMeisaiTable('syukkosuu')))
                  }, [
                    _createElementVNode("span", null, _toDisplayString(showMeisaiSortSymbol("syukkosuu")), 1),
                    _createTextVNode("出庫数 ")
                  ]),
                  _createElementVNode("th", {
                    class: "th_sort",
                    onClick: _cache[28] || (_cache[28] = ($event: any) => (sortMeisaiTable('syoumi')))
                  }, [
                    _createElementVNode("span", null, _toDisplayString(showMeisaiSortSymbol("syoumi")), 1),
                    _createTextVNode("正味 ")
                  ]),
                  _createElementVNode("th", {
                    class: "th_sort",
                    onClick: _cache[29] || (_cache[29] = ($event: any) => (sortMeisaiTable('syoumiPrice')))
                  }, [
                    _createElementVNode("span", null, _toDisplayString(showMeisaiSortSymbol("syoumiPrice")), 1),
                    _createTextVNode("正味金額 ")
                  ]),
                  _createElementVNode("th", {
                    class: "th_sort",
                    onClick: _cache[30] || (_cache[30] = ($event: any) => (sortMeisaiTable('hannyu')))
                  }, [
                    _createElementVNode("span", null, _toDisplayString(showMeisaiSortSymbol("hannyu")), 1),
                    _createTextVNode("搬入先 ")
                  ]),
                  _createElementVNode("th", {
                    class: "TH_Medium th_sort",
                    onClick: _cache[31] || (_cache[31] = ($event: any) => (sortMeisaiTable('nouhinDate')))
                  }, [
                    _createElementVNode("span", null, _toDisplayString(showMeisaiSortSymbol("nouhinDate")), 1),
                    _createTextVNode("納品日付 ")
                  ]),
                  _createElementVNode("th", {
                    class: "th_sort",
                    onClick: _cache[32] || (_cache[32] = ($event: any) => (sortMeisaiTable('orderNumber')))
                  }, [
                    _createElementVNode("span", null, _toDisplayString(showMeisaiSortSymbol("orderNumber")), 1),
                    _createTextVNode("納品番号 ")
                  ]),
                  _createElementVNode("th", {
                    class: "th_sort",
                    onClick: _cache[33] || (_cache[33] = ($event: any) => (sortMeisaiTable('seikyuDate')))
                  }, [
                    _createElementVNode("span", null, _toDisplayString(showMeisaiSortSymbol("seikyuDate")), 1),
                    _createTextVNode("請求日付 ")
                  ]),
                  _createElementVNode("th", {
                    class: "th_sort",
                    onClick: _cache[34] || (_cache[34] = ($event: any) => (sortMeisaiTable('syukkoStatus')))
                  }, [
                    _createElementVNode("span", null, _toDisplayString(showMeisaiSortSymbol("syukkoStatus")), 1),
                    _createTextVNode("状態 ")
                  ]),
                  _hoisted_27
                ])
              ]),
              (_unref(search_result).length)
                ? (_openBlock(), _createElementBlock("tbody", _hoisted_28, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(search_meisai_result), (result, index) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        class: _normalizeClass([result.isBgGray ? 'tr_bg-gray' : 'tr_bg-white', "tr-border"]),
                        key: index
                      }, [
                        _createElementVNode("td", _hoisted_29, _toDisplayString(result.tourokuDate), 1),
                        _createElementVNode("td", _hoisted_30, _toDisplayString(result.juchuNumber), 1),
                        _createElementVNode("td", null, _toDisplayString(result.client), 1),
                        _createElementVNode("td", null, _toDisplayString(result.registrant), 1),
                        _createElementVNode("td", null, _toDisplayString(result.eventMei), 1),
                        _createElementVNode("td", null, _toDisplayString(result.joukenMei), 1),
                        _createElementVNode("td", null, _toDisplayString(result.cycle), 1),
                        _createElementVNode("td", null, _toDisplayString(result.toritugiMei), 1),
                        _createElementVNode("td", null, _toDisplayString(result.syotenMei), 1),
                        _createElementVNode("td", null, _toDisplayString(result.tanzaku), 1),
                        _createElementVNode("td", null, _toDisplayString(result.nouhinRemarks), 1),
                        _createElementVNode("td", null, _toDisplayString(result.sagyouRemarks), 1),
                        _createElementVNode("td", null, _toDisplayString(result.toritugiSyotenCd), 1),
                        _createElementVNode("td", null, _toDisplayString(result.bansen), 1),
                        _createElementVNode("td", null, [
                          (
                    result.confirmedDenpyouNumber !== null &&
                    result.confirmedDenpyouNumber !== '0'
                  )
                            ? (_openBlock(), _createElementBlock("a", {
                                key: 0,
                                onClick: ($event: any) => (openDeliverySlip(result.confirmedDenpyouNumber))
                              }, _toDisplayString(result.confirmedDenpyouNumber), 9, _hoisted_31))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("td", null, _toDisplayString(result.detailNumber), 1),
                        _createElementVNode("td", null, _toDisplayString(result.syosiCd), 1),
                        _createElementVNode("td", null, _toDisplayString(result.janCd), 1),
                        _createElementVNode("td", null, _toDisplayString(result.syuppanSyosiCd), 1),
                        _createElementVNode("td", null, _toDisplayString(result.title), 1),
                        _createElementVNode("td", null, _toDisplayString(result.hontaiPrice), 1),
                        _createElementVNode("td", null, _toDisplayString(result.juchusuu), 1),
                        _createElementVNode("td", null, _toDisplayString(result.syukkosuu), 1),
                        _createElementVNode("td", null, _toDisplayString(result.syoumi), 1),
                        _createElementVNode("td", null, _toDisplayString(result.syoumiPrice), 1),
                        _createElementVNode("td", null, _toDisplayString(result.hannyu), 1),
                        _createElementVNode("td", null, _toDisplayString(result.nouhinDate), 1),
                        _createElementVNode("td", null, _toDisplayString(result.orderNumber), 1),
                        _createElementVNode("td", null, _toDisplayString(result.seikyuDate), 1),
                        _createElementVNode("td", null, _toDisplayString(result.syukkoStatus), 1),
                        _createElementVNode("td", null, [
                          (
                    result.syukkoStatus === '品切' &&
                    result.horyuSaiSyukkoJuchuNumber !== null
                  )
                            ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                                _createElementVNode("button", {
                                  class: "ShippingHistoryDetail_Button",
                                  onClick: ($event: any) => (openTab(result.horyuSaiSyukkoJuchuNumber))
                                }, " 保留再出庫 ", 8, _hoisted_33)
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ], 2))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ]),
            (!_unref(search_meisai_result).length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_34, " ※検索結果はありません "))
              : _createCommentVNode("", true)
          ], 64))
    ], 2)
  ], 2))
}
}

})